<template>
    <div class="border-0">
        <app-overlay-loader v-if="preloader" />
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 comments-datatable">
            
            <div v-if="!preloader && this.messages.total > 0" class="row p-2">
                <div class="mb-3" :class="mail.type == 'outbound' ? 'col-sm-12 col-md-10 offset-md-4' : 'col-sm-12 col-md-10'" v-for="(mail, index) in this.messages.data" :key="index">
                    <span class="text-muted">
                        <strong>{{ mail.from_name }}</strong>,
                        {{ formatEventDate(mail.date) }}
                    </span>
                    <div
                        style="    background-color: rgba(250, 175, 59, 0.15);
                                                        padding: 11px 15px !important;
                                                        padding-bottom: 1.5rem !important;
                                                        border: none !important;
                                                        border-radius: 5px;
                                                        display: block;
                                                        width: 100%;
                                                        font-size: 17px;
                                                        white-space: pre-wrap;"
                        v-html="mail.text_body"
                    ></div>
                </div>
            </div>
            <div v-else class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 comments-datatable text-center text-muted">
                Zatím žádné zprávy s uchazečem
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Mailbox",
    props: {
        mailboxMessages: Object,
    },
    watch: {
        mailboxMessages: {
            immediate: true, 
            handler (val, oldVal) {
                this.preloader = false;
                this.messages = this.mailboxMessages;
            }
        }
    },
    data() {
        return {
            preloader: true,
            messages: [],
            tableCommentId: "mailbox-table",
        };
    },
    mounted() {
        this.messages = this.mailboxMessages;
    },
    methods: {
        formatEventDate(date) {
            let formattedDate = " – " + this.$t("no_date");
            if (date) {
                formattedDate = moment(date).format("DD. MM. HH:mm");
                this.hasEventDate = true;
            }
            return formattedDate;
        },
    },
};
</script>
